/**
 * Created by senani on 12/19/18.
 */

import React, {Component, Fragment} from "react";
import "./OrderConfirmation.css";
import "../../../Common/ResponsiveOrderConfirmation.css";
import "../../../Common/Responsive.css";
import OrderItemTable from '../OrderItemTable/OrderItemTable';
import OrderConfirmationBottom from '../OrderConfirmationBottom/OrderConfirmationBottom';

import {FormattedMessage} from "react-intl";
import axios from "axios";
import {GOOGLE_ANALYTICS_CODE, RESOURCE_BASE_URL} from "../../../../configuration";
import AddressInfo from "./AddressInfo/AddressInfo";
import NumberFormatter from "../../../Common/NumberFormatter/NumberFormatter";
import Modal from "react-bootstrap/es/Modal";
import EditAddress from "../EditAddress/EditAddress";
import PriceLoadingImage from "../../../../assets/img/loading_price.gif";
import GoogleAds from "../../../Common/GoogleAds/GoogleAds";
import canvasDown from "../../../../assets/img/canvasdown.png";
import canvasUp from "../../../../assets/img/canvasup.png";
import ReactGA from "react-ga";
import paypal from '../../../../assets/img/paypal-order.png'
import masterVisa from '../../../../assets/img/visa masterAmericanExpress-order.png'
import remoteDeliveryFee from '../../../../assets/img/remoteDeliveryFee.png'

const EditAddressComponent = (props) => {
    return (
        <div>
            <div className="col-md-8 no-address-text no-padding">
                注文を進めることができません。請求先住所とお届け先住所を設定してください。
            </div>
            <div className="col-md-4">
                <EditAddress userId={props.userId}
                             shippingAddressId={props.userDetails.shippingAddressId}
                             userAddresses={props.userAddresses}
                             getUserAddresses={props.getUserDetails}
                             onAddressSelect={props.onAddressSelect}
                             userInfo={props.userDetails}
                             getUserDetails={props.getUserDetails}
                             type={props.type}/>
            </div>

        </div>

    )
};

var temProps;
var temPrevProps;
var tempPevState;
var temsSnapshot;

class OrderConfirmation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userId: this.props.userId,
            checkedItems: [],
            userDetails: {},
            userAddresses: [],
            cartItems: [],
            shippingAddress: null,
            billingAddress: null,
            subtotalVal: 0,
            consumpTaxVal: 0,
            summary: {
                subTotalOfItems: 0,
                totalTaxAmount: 0,
                shippingAmount: 0,
                cartTotal: 0,
                discount: {
                    discountCategory: "",
                    discountType: "",
                    discountAmount: 0
                }
            },
            discount: 0,
            orderTotal: 0,
            itemCount: 0,
            radioPaymentMethod: true
        };

        this.getUserDetails = this.getUserDetails.bind(this);
        this.getCartItems = this.getCartItems.bind(this);
        this.shippingAddressChanged = this.shippingAddressChanged.bind(this);
        this.billingAddressChanged = this.billingAddressChanged.bind(this);
        this.handleModelClose = this.handleModelClose.bind(this);
        this.handleModelShow = this.handleModelShow.bind(this);
        this.turnOnOverlayConfirm = this.turnOnOverlayConfirm.bind(this);
        this.turnOffOverlayConfirm = this.turnOffOverlayConfirm.bind(this);
        this.changePaymentByPaypal = this.changePaymentByPaypal.bind(this);
        this.changePaymentByCard = this.changePaymentByCard.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        temPrevProps = prevProps;
        tempPevState = prevState;
        temsSnapshot = snapshot;
        if (prevProps.userData !== this.props.userData) {
            this.setState({userId: this.props.userId});
            this.getUserDetails(this.props.userId);
            this.getCartItems(this.props.userId);
        }

    }

    componentDidMount() {
        this.getUserDetails(this.props.userId);
        this.getCartItems(this.props.userId, this.props.location.selectedItems);
        temProps = this.props;

        console.log('selected items---------------------------------------------  ', this.props.location.selectedItems)
        let coll = document.getElementsByClassName("collapsible-order");
        let i;

        for (i = 0; i < coll.length; i++) {
            coll[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var content = this.nextElementSibling;
                if (content.style.maxHeight) {
                    content.style.maxHeight = null;
                } else {
                    content.style.maxHeight = content.scrollHeight + "px";
                }
            });
        }

    }

    componentWillUnmount() {
        if (temPrevProps.userData !== temProps.userData && temProps.userData != null) {
            this.setState({userId: temProps.userId});
            this.getUserDetails(temProps.userId);
            this.getCartItems(temProps.userId);
        }
        this.getUserDetails(temProps.userId);
        this.getCartItems(temProps.userId, temProps.location.selectedItems);
    }


    getUserDetails = (userId) => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/' + userId, axiosConfig)
            .then((res) => {

                this.setState({
                    userDetails: res.data,
                    shippingAddress: res.data.shippingAddress,
                    billingAddress: res.data.billingAddress,
                    userAddresses: res.data.addressList
                });
                console.log("GET USER DETAILS DUO ====> ", res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    getCartItems = (userId, selectedItems) => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.post(RESOURCE_BASE_URL + 'api/users/' + userId + '/cart/item/amount/1', selectedItems, axiosConfig)
            .then((res) => {
                this.setState({
                    summary: res.data.cartSummary,
                    itemCount: res.data.itemCount,
                    cartItems: res.data.cartItems
                });

                // console.log("SUMMARY CONFIRM DUO ===> ", res.data);
                let checkedItems = this.props.location.selectedItems;
                let cartItems = [...this.state.cartItems];
                checkedItems.forEach(function (itemId) {

                    res.data.forEach(function (item) {
                        if (item.id === itemId) {
                            let record = cartItems.push(item)
                        }
                    });
                });

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };


    shippingAddressChanged = (item) => {
        this.updateAddress({shippingAddressId: item.id}, () => this.getUserDetails(this.props.userId));
    };

    billingAddressChanged = (item) => {
        this.updateAddress({billingAddressId: item.id}, () => this.getUserDetails(this.props.userId));
    };


    handleModelShow = () => {
        this.setState({
            showModal: true
        })
    };

    handleModelClose = () => {
        this.setState({
            showModal: false
        })
    };

    updateAddress = (data) => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        let putData = {
            ...this.state.userDetails, ...data
        };


        axios.put(RESOURCE_BASE_URL + 'api/users/' + this.props.userId, putData, axiosConfig)
            .then((res) => {
                this.getUserDetails(this.props.userId);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };


    turnOnOverlayConfirm = () => {
        document.getElementById("overlay-ord-confirm").style.display = "block";
    };
    turnOffOverlayConfirm = () => {
        document.getElementById("overlay-ord-confirm").style.display = "none";
    };

    changePaymentByPaypal(e) {
        this.setState({
            radioPaymentMethod: false
        })

    }

    changePaymentByCard(e) {
        this.setState({
            radioPaymentMethod: true
        })
    }

    render() {
        ReactGA.initialize(GOOGLE_ANALYTICS_CODE);
        ReactGA.pageview(window.location.pathname + window.location.search);

        let orderTotal = this.state.summary.cartTotal;
        let discount = this.state.summary.discount.discountAmount;
        let taxAmount = this.state.summary.totalTaxAmount;
        let subTotal = this.state.summary.subTotalOfItems;
        let itemCount = this.state.itemCount;
        // this.state.cartItems.map((item) => {
        //     orderTotal += item.chargeDetails.totalPrice;
        // });
        return (
            <Fragment>
                <div className="order-confirmation-content web-view">
                    <GoogleAds slot="696274611"/>
                    <div id="overlay-ord-confirm">
                        <div id="text-ord-confirm">
                            <img className="" src={PriceLoadingImage} alt="Loading..."/> &nbsp; お待ちください
                        </div>
                    </div>
                    <div className="order-confirmation-div">
                        <div className="title-1">
                            <FormattedMessage id="app.order.confirm.title"
                                              defaultMessage="ORDER CONFIRMATION"
                                              description=""/>
                        </div>
                        <br/>
                        <div className="title-1">
                            <FormattedMessage id="app.order.confirm.sub-title"
                                              defaultMessage="About delivery address"
                                              description=""/>
                        </div>
                        <hr/>
                        <div className="order-confirm-text">ご住所は正しく入力してください。</div>
                        <div className="order-confirm-text">不足や誤りがあると商品のお届けができない場合があります。</div>
                        <div className="order-confirm-text">新しいお届け先、請求先住所を入力する場合は、編集より追加してください。</div>
                        <br/>

                        <div>
                            <div className="row order-confirm-header-row no-padding">
                                <div className="col-md-4">
                                    <label>お客様情報</label>
                                </div>
                                <div className="col-md-4">
                                    <label>お届け先住所</label>
                                </div>
                                <div className="col-md-4">
                                    <label>請求先住所</label>
                                </div>
                            </div>
                            <br/>

                            <div className="row order-confirm-border no-padding">
                                <div className="col-md-4 order-confirm-border-right">

                                    <div>
                                        <label className="order-confirmation-user-details-resp">
                                            ユーザー名
                                            :

                                        </label>
                                        {this.state.userDetails.username}
                                    </div>
                                    <div>
                                        <label className="order-confirmation-user-details-resp">

                                            <FormattedMessage id="app.order.confirm.customer.name"
                                                              defaultMessage="Customer Information"
                                                              description=""/> :

                                        </label>
                                        {this.state.userDetails.japaneseLastName +" "+this.state.userDetails.japaneseFirstName}
                                    </div>
                                    <div>
                                        <label className="order-confirmation-user-details-resp">

                                            <FormattedMessage id="app.order.confirm.customer.email"
                                                              defaultMessage="Customer Information"
                                                              description=""/> :

                                        </label>
                                        {this.state.userDetails.email}
                                    </div>
                                    <div>
                                        <label className="order-confirmation-user-details-resp">
                                            <FormattedMessage id="app.order.confirm.customer.phone"
                                                              defaultMessage="Customer Information"
                                                              description=""/> :
                                        </label>
                                        {this.state.userDetails.phone}
                                    </div>
                                </div>
                                <div className="col-md-4 order-confirm-border-right">
                                    {this.state.shippingAddress !== null ?
                                        <AddressInfo userId={this.props.userId}
                                                     userDetails={this.state.userDetails}
                                                     addressDetails={this.state.shippingAddress}
                                                     userAddresses={this.state.userDetails.addressList}
                                                     onAddressSelect={this.shippingAddressChanged}
                                                     getUserDetails={this.getUserDetails}
                                                     address={this.state.shippingAddress}
                                                     type="shipping"/> :
                                        ""
                                    }
                                </div>
                                <div className="col-md-4 order-confirm-border-right">
                                    {this.state.billingAddress !== null ?
                                        <AddressInfo userId={this.props.userId}
                                                     userDetails={this.state.userDetails}
                                                     addressDetails={this.state.billingAddress}
                                                     userAddresses={this.state.userDetails.addressList}
                                                     onAddressSelect={this.billingAddressChanged}
                                                     getUserDetails={this.getUserDetails}
                                                     address={this.state.billingAddress}
                                                     type="billing"/> :
                                        ""
                                    }
                                </div>
                            </div>

                        </div>
                        <br/>

                        <div>
                            <div className="row order-confirm-header-row no-padding">
                                <div className="col-md-4">
                                    <label>
                                        <FormattedMessage id="app.order.confirm.shipping.method"
                                                          defaultMessage="Shipping Method"
                                                          description=""/>
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    <label>
                                        <FormattedMessage id="app.order.confirm.payment.method"
                                                          defaultMessage="Payment Method"
                                                          description=""/>
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    <label>注文内容</label>
                                </div>
                            </div>
                            <br/>

                            <div className="row order-confirm-border no-padding">
                                <div className="col-md-4">
                                    <ul>
                                        <li> SGX(佐川国際宅配便)</li>
                                    </ul>
                                    <ul class="remote-delivery-fee">
                                        <li> ※離島エリアへ配送する場合は、別途「離島中継手数料」が掛かります。</li>
                                        <li> （ご注文頂いた金額が￥10,000を超える場合は、「離島中継手数料」は無料になります。）</li>
                                    </ul>
                                    <div className='image-align-order'>
                                        <img className="remote-delivery-fee-table" src={remoteDeliveryFee} alt=""/>
                                    </div>
                                </div>
                                <div className="col-md-4 payment-caption-col">
                                    {/*    <div className="payment-caption">*/}
                                    {/*        <span>サービス数は世界で２憶5000万人以上、1800万以上の店舗で利用されている安心でかんたんなオンライン決済サービスです。</span>*/}
                                    {/*    </div>*/}
                                    {/*    <br/>*/}
                                    {/*    <div className="row no-margin no-padding">*/}
                                    {/*        <br/>*/}
                                    {/*        <span>*/}
                                    {/*   <ul>*/}
                                    {/*       <li className="paypal-label-img">*/}
                                    {/*           <span className="paypal-label">PAYPALで支払う</span>*/}
                                    {/*           <br/><br/>*/}
                                    {/*     <a href="#"*/}
                                    {/*        onClick="javascript:window.open('https://www.paypal.com/jp/webapps/mpp/logo/about','olcwhatispaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=900, height=700');">*/}
                                    {/*             <img*/}
                                    {/*                 src="https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/jp/developer/203x80_b.png"*/}
                                    {/*                 border="0"*/}
                                    {/*                 alt="ペイパル｜カード情報も、口座番号も、ペイパルが守ります。｜VISA, Mastercard, JCB, American Express, Union Pay, 銀行"/>*/}
                                    {/*                </a>*/}
                                    {/*   </li>*/}
                                    {/*   </ul>*/}
                                    {/*</span>*/}
                                    {/*    </div>*/}
                                    <div className="div-height-order-outer">
                                        <div className="div-height-order">
                                            <input type="radio" value={2} defaultChecked={true} onChange={this.changePaymentByCard}
                                                   checked={this.state.radioPaymentMethod}/>
                                            <span>クレジットカードで支払う</span>
                                            <br/>
                                            <div className='image-align-order'>

                                            <img className="payPal-visa-card" src={masterVisa} alt=""/>
                                            </div>
                                        </div>
                                        {/*<hr/>*/}

                                        <div className="div-height-order">
                                            <input type="radio" value={1}
                                                   onChange={this.changePaymentByPaypal}
                                                   checked={!this.state.radioPaymentMethod}/>
                                            <span>PayPalアカウントで支払う</span>
                                            <br/>
                                            <div className='image-align-order'>

                                            <img className="payPal-visa-card" src={paypal} alt=""/>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <div className="col-md-5">
                                    <span className="order-total-value">
                                         アイテム数</span>
                                        </div>
                                        <div className="col-md-2 view-single-order-total colon-money">:</div>
                                        <div className="col-md-5">
                                            <span className="order-total-value pull-left">{itemCount}</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="col-md-5">
                                <span className="order-total-value">
                                         <FormattedMessage id="app.order.confirm.table.sub-total"
                                                           defaultMessage="Sub Total"
                                                           description=""/></span>
                                        </div>
                                        <div className="col-md-2 view-single-order-total">:</div>
                                        <div className="col-md-5">
                                        <span className="order-total-value pull-left">¥ <NumberFormatter
                                            num={subTotal}/></span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="col-md-5">
                                <span className="order-total-value">
                                         <FormattedMessage id="app.order.confirm.order.discount"
                                                           defaultMessage="Discount:"
                                                           description=""/></span>
                                        </div>
                                        <div className="col-md-2 view-single-order-total">:</div>
                                        <div className="col-md-5">
                                <span className="order-total-value pull-left">¥ <NumberFormatter
                                    num={discount}/></span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="col-md-5">
                                <span className="order-total-value">
                                         <FormattedMessage id="app.order.confirm.order.tax"
                                                           defaultMessage="Tax (8%):"
                                                           description=""/></span>
                                        </div>
                                        <div className="col-md-2 view-single-order-total">:</div>
                                        <div className="col-md-5">
                                <span className="order-total-value pull-left">¥ <NumberFormatter
                                    num={taxAmount}/></span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="col-md-5">
                                <span className="order-total-value">
                                         <FormattedMessage id="app.order.confirm.order.total"
                                                           defaultMessage="Order Total:"
                                                           description=""/></span>
                                        </div>
                                        <div className="col-md-2 view-single-order-total">:</div>
                                        <div className="col-md-5">
                                <span className="order-total-value pull-left">¥ <NumberFormatter
                                    num={orderTotal}/></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br/>
                        <OrderItemTable
                            userId={this.props.userId}
                            cartItems={this.state.cartItems}
                        />
                        <br/>
                        {this.state.billingAddress == null || this.state.shippingAddress == null ?
                            <EditAddressComponent userId={this.state.userId}
                                                  shippingAddressId={"-1"}
                                                  userAddresses={this.state.userAddresses}
                                                  getUserAddresses={this.getUserAddresses}
                                                  onAddressSelect={this.shippingAddressChanged}
                                                  userDetails={this.state.userDetails}
                                                  getUserDetails={this.getUserDetails}
                                                  type={"shipping"}/>
                            :
                            <OrderConfirmationBottom
                                orderTotal={orderTotal}
                                discount={discount}
                                userId={this.props.userId}
                                userDetails={this.state.userDetails}
                                cartItemIds={this.props.location.selectedItems}
                                getCartItems={this.props.getCartItems}
                                getUserDetails={this.getUserDetails}
                                billingAddress={this.state.billingAddress}
                                shippingAddress={this.state.shippingAddress}
                                turnOnOverlayConfirm={this.turnOnOverlayConfirm}
                                turnOffOverlayConfirm={this.turnOffOverlayConfirm}
                                paymentByPaypal={this.state.radioPaymentMethod}
                            />

                        }

                    </div>


                </div>
                <div className="mobile-view responsive-order-confirmation">
                    <GoogleAds slot="696274611"/>
                    <div id="overlay-ord-confirm">
                        <div id="text-ord-confirm">
                            <img className="" src={PriceLoadingImage} alt="Loading..."/> &nbsp; お待ちください
                        </div>
                    </div>
                    <div className="mobile-view-order-confirmation-heading">
                        <FormattedMessage id="app.order.confirm.title"
                                          defaultMessage="ORDER CONFIRMATION"
                                          description=""/>
                    </div>
                    <hr/>
                    <div>
                        <button className="collapsible-order">
                            <FormattedMessage id="app.order.confirm.sub-title"
                                              defaultMessage="About delivery address"
                                              description=""/>
                            <img src={canvasDown} alt="" width='25px' className="plus"/>
                            <img src={canvasUp} alt="" width='25px' className="minus"/>
                        </button>
                        <div className="content-order">
                            <div>
                                <p>ご住所は正しく入力してください。</p>
                                <p>不足や誤りがあると商品のお届けができない場合があります。</p>
                                <p>新しいお届け先、請求先住所を入力する場合は、編集より追加してください。</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button className="collapsible-order">
                            お客様情報
                            <img src={canvasDown} alt="" width='25px' className="plus"/>
                            <img src={canvasUp} alt="" width='25px' className="minus"/>
                        </button>
                        <div className="content-order">
                            <div>
                                <label>
                                    <FormattedMessage id="app.order.confirm.customer.name"
                                                      defaultMessage="Customer Information"
                                                      description=""/> :
                                </label>
                                {this.state.userDetails.name}
                            </div>

                            <div>
                                <label>

                                    <FormattedMessage id="app.order.confirm.customer.email"
                                                      defaultMessage="Customer Information"
                                                      description=""/> :

                                </label>
                                {this.state.userDetails.email}
                            </div>
                            <div>
                                <label>
                                    <FormattedMessage id="app.order.confirm.customer.phone"
                                                      defaultMessage="Customer Information"
                                                      description=""/> :
                                </label>
                                {this.state.userDetails.phone}
                            </div>
                        </div>
                    </div>
                    <div>
                        <button className="collapsible-order">
                            お届け先住所
                            <img src={canvasDown} alt="" width='25px' className="plus"/>
                            <img src={canvasUp} alt="" width='25px' className="minus"/>
                        </button>
                        <div className="content-order">
                            <div>
                                {this.state.shippingAddress !== null ?
                                    <AddressInfo userId={this.props.userId}
                                                 userDetails={this.state.userDetails}
                                                 addressDetails={this.state.shippingAddress}
                                                 userAddresses={this.state.userDetails.addressList}
                                                 onAddressSelect={this.shippingAddressChanged}
                                                 getUserDetails={this.getUserDetails}
                                                 address={this.state.shippingAddress}
                                                 type="shipping"/> :
                                    ""
                                }
                            </div>
                        </div>
                    </div>
                    <div>
                        <button className="collapsible-order">
                            請求先住所
                            <img src={canvasDown} alt="" width='25px' className="plus"/>
                            <img src={canvasUp} alt="" width='25px' className="minus"/>
                        </button>
                        <div className="content-order">
                            <div>
                                {this.state.billingAddress !== null ?
                                    <AddressInfo userId={this.props.userId}
                                                 userDetails={this.state.userDetails}
                                                 addressDetails={this.state.billingAddress}
                                                 userAddresses={this.state.userDetails.addressList}
                                                 onAddressSelect={this.billingAddressChanged}
                                                 getUserDetails={this.getUserDetails}
                                                 address={this.state.billingAddress}
                                                 type="billing"/> :
                                    ""
                                }
                            </div>
                        </div>
                    </div>
                    <div>
                        <button className="collapsible-order">
                            <FormattedMessage id="app.order.confirm.shipping.method"
                                              defaultMessage="Shipping Method"
                                              description=""/>
                            <img src={canvasDown} alt="" width='25px' className="plus"/>
                            <img src={canvasUp} alt="" width='25px' className="minus"/>
                        </button>
                        <div className="content-order">
                            <div>
                                SGX(佐川国際宅配便)
                            </div>
                            <div>
                                ※離島エリアへ配送する場合は、別途「離島中継手数料」が掛かります。
                            </div>
                            <div>
                                （ご注文頂いた金額が￥10,000を超える場合は、「離島中継手数料」は無料になります。）
                            </div>
                            <div className='image-align-order'>
                                <img className="remote-delivery-fee-table" src={remoteDeliveryFee} alt=""/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button className="collapsible-order">
                            <FormattedMessage id="app.order.confirm.payment.method"
                                              defaultMessage="Payment Method"
                                              description=""/>
                            <img src={canvasDown} alt="" width='25px' className="plus"/>
                            <img src={canvasUp} alt="" width='25px' className="minus"/>
                        </button>
                        <div className="content-order ">
                            {/*<div>*/}
                            {/*    <span>サービス数は世界で２憶5000万人以上、1800万以上の店舗で利用されている安心でかんたんなオンライン決済サービスです。</span>*/}
                            {/*    <br/>*/}
                            {/*    <br/>*/}
                            {/*    PAYPALで支払う*/}
                            {/*    <br/>*/}
                            {/*    <br/>*/}
                            {/*    <a href="#"*/}
                            {/*       onClick="javascript:window.open('https://www.paypal.com/jp/webapps/mpp/logo/about','olcwhatispaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=900, height=700');">*/}
                            {/*        <img*/}
                            {/*            src="https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/jp/developer/203x80_b.png"*/}
                            {/*            border="0"*/}
                            {/*            alt="ペイパル｜カード情報も、口座番号も、ペイパルが守ります。｜VISA, Mastercard, JCB, American Express, Union Pay, 銀行"/>*/}
                            {/*    </a>*/}

                            {/*</div>*/}

                            <input type="radio" value={2}  defaultChecked={true} onChange={this.changePaymentByCard}
                                   checked={this.state.radioPaymentMethod}/>
                            <span>クレジットカードで支払う</span>
                            <div className='image-align-order'>
                                <img className="payPal-visa-card-mobile" src={masterVisa} alt=""/>

                            </div>

                            <hr/>

                            <input type="radio" value={1}
                                   onChange={this.changePaymentByPaypal}
                                   checked={!this.state.radioPaymentMethod}/>
                            <span>PayPalアカウントで支払う</span>
                            <div className='image-align-order'>
                                <img className="payPal-visa-card-mobile" src={paypal} alt=""/>
                            </div>

                        </div>


                    </div>
                    <div>
                        <button className="collapsible-order">
                            注文内容
                            <img src={canvasDown} alt="" width='25px' className="plus"/>
                            <img src={canvasUp} alt="" width='25px' className="minus"/>
                        </button>
                        <div className="content-order">
                            <div>
                                <div className="order-summary-responsive">
                                    <div className="custom-col-5">
                                        <FormattedMessage id="app.order.confirm.table.qty"
                                                          defaultMessage="Item Qty"
                                                          description=""/>
                                    </div>
                                    <div className="custom-col-2">:</div>
                                    <div className="custom-col-5">
                                        {itemCount}
                                    </div>
                                </div>
                                <div className="order-summary-responsive">
                                    <div className="custom-col-5">
                                        <FormattedMessage id="app.order.confirm.table.sub-total"
                                                          defaultMessage="Sub Total"
                                                          description=""/>
                                    </div>
                                    <div className="custom-col-2">:</div>
                                    <div className="custom-col-5">
                                        ¥ <NumberFormatter num={subTotal}/>
                                    </div>
                                </div>
                                <div className="order-summary-responsive">
                                    <div className="custom-col-5">
                                        <FormattedMessage id="app.order.confirm.order.discount"
                                                          defaultMessage="Discount"
                                                          description=""/>
                                    </div>
                                    <div className="custom-col-2">:</div>
                                    <div className="custom-col-5">
                                        ¥ <NumberFormatter num={discount}/>
                                    </div>
                                </div>
                                <div className="order-summary-responsive">
                                    <div className="custom-col-5">
                                        <FormattedMessage id="app.order.confirm.order.tax"
                                                          defaultMessage="Tax (8%)"
                                                          description=""/>
                                    </div>
                                    <div className="custom-col-2">:</div>
                                    <div className="custom-col-5">
                                        ¥ <NumberFormatter num={taxAmount}/>
                                    </div>
                                </div>
                                <div className="order-summary-responsive">
                                    <div className="custom-col-5">
                                        <FormattedMessage id="app.order.confirm.order.total"
                                                          defaultMessage="Order Total"
                                                          description=""/>
                                    </div>
                                    <div className="custom-col-2">:</div>
                                    <div className="custom-col-5">
                                        ¥ <NumberFormatter num={orderTotal}/>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="mobile-view-order-confirmation-heading">
                        選択したアイテム
                    </div>
                    <hr/>
                    <div>
                        <OrderItemTable
                            userId={this.props.userId}
                            cartItems={this.state.cartItems}
                        />
                    </div>
                    <hr/>
                    <div>
                        <div className="responsive-order-item-bottom-total">
                            <p>注文合計 : ¥ <NumberFormatter num={orderTotal}/></p>
                        </div>
                    </div>
                    <hr/>
                    <div>
                        {this.state.billingAddress == null || this.state.shippingAddress == null ?
                            <EditAddressComponent userId={this.state.userId}
                                                  shippingAddressId={"-1"}
                                                  userAddresses={this.state.userAddresses}
                                                  getUserAddresses={this.getUserAddresses}
                                                  onAddressSelect={this.shippingAddressChanged}
                                                  userDetails={this.state.userDetails}
                                                  getUserDetails={this.getUserDetails}
                                                  type={"shipping"}/>
                            :
                            <OrderConfirmationBottom
                                orderTotal={orderTotal}
                                discount={discount}
                                userId={this.props.userId}
                                cartItemIds={this.props.location.selectedItems}
                                getCartItems={this.props.getCartItems}
                                getUserDetails={this.getUserDetails}
                                billingAddress={this.state.billingAddress}
                                shippingAddress={this.state.shippingAddress}
                                turnOnOverlayConfirm={this.turnOnOverlayConfirm}
                                turnOffOverlayConfirm={this.turnOffOverlayConfirm}
                                userDetails={this.state.userDetails}
                                paymentByPaypal={this.state.radioPaymentMethod}
                            />

                        }
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default OrderConfirmation;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderConfirmation/OrderConfirmation.js